import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { supabase } from '../supabase';
import MonsterStatBlock from './MonsterStatBlock';

const BUCKET = 'Monsters';

function MonsterView() {
  const { fileName } = useParams();
  const [monster, setMonster] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!fileName) return;
    async function fetchMonster() {
      try {
        setError(null);
        console.log('[MonsterView] Downloading:', BUCKET, fileName);
        const { data, error: err } = await supabase.storage.from(BUCKET).download(fileName);
        if (err) {
          console.error('[MonsterView] Download error:', err);
          throw err;
        }
        const text = await data.text();
        const parsed = JSON.parse(text);
        console.log('[MonsterView] Loaded monster:', parsed?.name);
        setMonster(parsed);
      } catch (e) {
        console.error('[MonsterView] Caught error:', e);
        setError(e.message || 'Failed to load monster');
        setMonster(null);
      } finally {
        setLoading(false);
      }
    }
    fetchMonster();
  }, [fileName]);

  if (loading) return <section className="section"><div className="container"><p>Loading...</p></div></section>;
  if (error || !monster) {
    return (
      <section className="section">
        <div className="container">
          <div className="notification is-warning">
            {error || 'Monster not found'}
          </div>
          <Link to="/monsters" className="button">Back to list</Link>
        </div>
      </section>
    );
  }

  return (
    <section className="section">
      <div className="container">
        <MonsterStatBlock monster={monster} fileName={fileName} canEdit canSave />
      </div>
    </section>
  );
}

export default MonsterView;
